import { render, staticRenderFns } from "./CatalogLine.vue?vue&type=template&id=479a53cf&scoped=true"
import script from "./CatalogLine.vue?vue&type=script&lang=js"
export * from "./CatalogLine.vue?vue&type=script&lang=js"
import style0 from "./CatalogLine.vue?vue&type=style&index=0&id=479a53cf&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a53cf",
  null
  
)

export default component.exports